export { defaultBatchingConfig, defaultGlobalObjectKey } from './const';

export type { Config, Patterns } from './types';



// WEBPACK FOOTER //
// ../../../src/config/index.ts